module.exports = __webpack_public_path__ + "img/internet-alert.bdb89a8d.svg";